import React from 'react';
import {RouterProvider} from 'react-router-dom';
import appRoutes from './router/AppRoutes';
import {MantineProvider} from "@mantine/core";
import './App.module.scss';

const theme = {
  primaryColor: 'indigo',
  defaultRadius: 'md',
} as const;

function App(_: {}) {
  return (
    <MantineProvider theme={theme as any}>
      <RouterProvider router={appRoutes}/>
    </MantineProvider>
  );
}
export default App;
